export default "__VITE_ASSET__96200d30__"